module.exports = __webpack_public_path__ + "static/box-44b3f233e979a037a20f7f7051218bcf.png";